import { render, staticRenderFns } from "./receivePostcard.vue?vue&type=template&id=3f1d6bd8&scoped=true"
import script from "./receivePostcard.vue?vue&type=script&lang=js"
export * from "./receivePostcard.vue?vue&type=script&lang=js"
import style0 from "./receivePostcard.vue?vue&type=style&index=0&id=3f1d6bd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1d6bd8",
  null
  
)

export default component.exports